import React from "react";
import styled from "styled-components";

import { getTabBarTotalHeight } from "../../constants/tabBarLayout";
import { tokens } from "../../theme/tokens";
import PageHeader from "../PageHeader";
import BottomNavigation from "../BottomNavigation";
import AdComponent from "../AdComponent";

const { mobileFirstExpandPx, appShellNarrowMaxPx, headerFooterInnerMaxPx } =
  tokens.layout;

const tabBarBottomClearance = getTabBarTotalHeight();

const LayoutWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: ${({ theme }) => theme.colors.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  transition: background 0.25s ease;
`;

const ContentContainer = styled.main`
  width: 100%;
  max-width: ${appShellNarrowMaxPx}px;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 12px;
  padding-left: max(12px, env(safe-area-inset-left));
  padding-right: max(12px, env(safe-area-inset-right));
  padding-bottom: calc(
    var(--tab-bar-clearance, ${tabBarBottomClearance}px) + 12px
  );
  box-sizing: border-box;

  @media (min-width: ${mobileFirstExpandPx}px) {
    max-width: ${headerFooterInnerMaxPx}px;
    width: 100%;
    padding-left: max(1.2rem, env(safe-area-inset-left));
    padding-right: max(1.2rem, env(safe-area-inset-right));
  }
`;

interface MobileLayoutProps {
  children: React.ReactNode;
  headerTitle: string;
  headerType?: "public" | "private" | "manager" | "dashboard";
  headerDescription?: string;
  headerSettingsHref?: string;
  showFooter?: boolean;
  showBannerAd?: boolean;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  headerTitle,
  headerType = "private",
  headerDescription,
  headerSettingsHref,
  showFooter = true,
  showBannerAd = true,
}) => {
  return (
    <LayoutWrapper>
      <PageHeader
        title={headerTitle}
        type={headerType}
        description={headerDescription}
        settingsHref={headerSettingsHref}
      />
      <ContentContainer>
        {children}
        {showBannerAd ? (
          <AdComponent
            style={{ marginTop: "auto", marginBottom: 8 }}
            className="mobile-layout-ad"
          />
        ) : null}
      </ContentContainer>
      {showFooter && <BottomNavigation />}
    </LayoutWrapper>
  );
};

export default MobileLayout;
